import React, { useState } from "react";

export default function PaymentForm() {
  const [formData, setFormData] = useState({
    transaction_id: "",
    payable_type: "",
    payable_id: "",
    amount: "",
    payment_method: "",
    status: "",
    paid_at: "",
  });
  const [errors, setErrors] = useState({});

  const paymentMethods = ["Cash", "MPesa", "Bank Transfer"];
  const statuses = ["Pending", "Completed", "Failed"];
  const payableTypes = ["Income", "Expense"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateInputs = () => {
    const errors = {};
    if (!formData.transaction_id) errors.transaction_id = "Transaction ID is required";
    if (!formData.payable_type) errors.payable_type = "Payable type is required";
    if (!formData.payable_id) errors.payable_id = "Payable ID is required";
    if (!formData.amount || isNaN(formData.amount) || formData.amount <= 0)
      errors.amount = "Valid amount is required";
    if (!formData.payment_method) errors.payment_method = "Payment method is required";
    if (!formData.status) errors.status = "Status is required";
    if (!formData.paid_at) errors.paid_at = "Payment date is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validateInputs()) {
      console.log("Payment submitted:", formData);
      // Submission logic here
    }
  };

  return (
    <div className="bg-white shadow-lg rounded-lg p-6 max-w-4xl mx-auto">
      <div className="flex flex-col">
        <div className="flex flex-row items-center justify-between p-4 bg-gray-200 rounded-t-lg">
          <h3 className="font-semibold text-lg text-gray-700">New Payment</h3>
          <button
            className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
        <form className="p-4 space-y-6">
          {/* Transaction ID */}
          <div className="mb-3">
            <input
              type="text"
              name="transaction_id"
              placeholder="Transaction ID"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.transaction_id}
              onChange={handleInputChange}
            />
            {errors.transaction_id && <p className="text-red-500 text-xs mt-1">{errors.transaction_id}</p>}
          </div>

          {/* Payable Type */}
          <div className="mb-3">
            <select
              name="payable_type"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.payable_type}
              onChange={handleInputChange}
            >
              <option value="">Select Payable Type</option>
              {payableTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
            {errors.payable_type && <p className="text-red-500 text-xs mt-1">{errors.payable_type}</p>}
          </div>

          {/* Payable ID */}
          <div className="mb-3">
            <input
              type="text"
              name="payable_id"
              placeholder="Payable ID"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.payable_id}
              onChange={handleInputChange}
            />
            {errors.payable_id && <p className="text-red-500 text-xs mt-1">{errors.payable_id}</p>}
          </div>

          {/* Amount */}
          <div className="mb-3">
            <input
              type="number"
              name="amount"
              placeholder="Amount"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.amount}
              onChange={handleInputChange}
            />
            {errors.amount && <p className="text-red-500 text-xs mt-1">{errors.amount}</p>}
          </div>

          {/* Payment Method */}
          <div className="mb-3">
            <select
              name="payment_method"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.payment_method}
              onChange={handleInputChange}
            >
              <option value="">Select Payment Method</option>
              {paymentMethods.map((method, index) => (
                <option key={index} value={method}>
                  {method}
                </option>
              ))}
            </select>
            {errors.payment_method && <p className="text-red-500 text-xs mt-1">{errors.payment_method}</p>}
          </div>

          {/* Status */}
          <div className="mb-3">
            <select
              name="status"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.status}
              onChange={handleInputChange}
            >
              <option value="">Select Status</option>
              {statuses.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
            {errors.status && <p className="text-red-500 text-xs mt-1">{errors.status}</p>}
          </div>

          {/* Paid At */}
          <div className="mb-3">
            <input
              type="datetime-local"
              name="paid_at"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.paid_at}
              onChange={handleInputChange}
            />
            {errors.paid_at && <p className="text-red-500 text-xs mt-1">{errors.paid_at}</p>}
          </div>
        </form>
      </div>
    </div>
  );
}
